import Vue from 'vue';
import VueI18n from 'vue-i18n';
import pt from '@/locales/pt.json';

Vue.use(VueI18n);

const messages = { pt };

export default new VueI18n({
  locale: 'pt',
  messages,
});
